import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../../../redux/actions/endpoints";
import { storage } from "../../../../../../../scopedStorage";
import "./reschedule.css";

const toastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  pauseOnHover: true,
  progress: undefined,
  theme: "light",
};

const todayISO = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const RescheduleButton = ({ onClick }) => (
  <button type="button" className="rescheduleBtn ml-3" onClick={onClick}>
    Reschedule
  </button>
);

const RescheduleModal = ({ show, handleClose, pickUp, onRescheduled }) => {
  const [pickupDate, setPickupDate] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setPickupDate("");
      setReason("");
    }
  }, [show]);

  const submit = (e) => {
    e.preventDefault();
    if (!pickupDate || !reason.trim()) {
      toast.error("Please select a new date and provide a reason", toastOptions);
      return;
    }
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .post(
        `${switchEndpoint}/collection-center/reschedule-pickup/${pickUp?.code}`,
        { pickup_date: pickupDate, reason: reason.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        toast.success(
          response?.data?.message || "Pick up rescheduled successfully",
          toastOptions
        );
        setLoading(false);
        handleClose();
        onRescheduled && onRescheduled();
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message || "Unable to reschedule pick up",
          toastOptions
        );
        setLoading(false);
      });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="rescheduleModal"
    >
      <Modal.Header closeButton>
        <Modal.Title as="h6">Reschedule Pick Up</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={submit} className="px-2">
          {pickUp && (
            <div className="mb-3" style={{ fontSize: "14px" }}>
              <p className="mb-1">
                <b>Code:</b> {pickUp.code}
              </p>
              {pickUp?.owner?.name && (
                <p className="mb-1">
                  <b>User:</b> {pickUp.owner.name}
                </p>
              )}
              {pickUp.date_type && (
                <p className="mb-1">
                  <b>Current schedule:</b> {pickUp.date_type}
                </p>
              )}
            </div>
          )}
          <div className="form-group">
            <label htmlFor="reschedule-date">New pickup date</label>
            <input
              id="reschedule-date"
              type="date"
              className="form-control"
              min={todayISO()}
              value={pickupDate}
              onChange={(e) => setPickupDate(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="reschedule-reason">Reason</label>
            <textarea
              id="reschedule-reason"
              className="form-control"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why is this pick up being rescheduled?"
              required
            />
          </div>
          <div className="row mt-4 mb-2">
            <div className="col-6">
              <button
                type="button"
                className="btn rescheduleCancelBtn btn-sm btn-block"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
            <div className="col-6">
              <button
                type="submit"
                className="btn rescheduleSubmitBtn btn-sm btn-block"
                disabled={loading}
              >
                {loading ? "Rescheduling ..." : "Reschedule"}
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default RescheduleModal;
